import { createFileRoute } from '@tanstack/react-router'
import { MatchHub, type HubSearch } from '~/features/matches/MatchHub'
import { formationsQuery, hubQuery, loaderScope, planQuery } from '~/features/matches/queries'

const TABS = ['vorbereitung', 'spieltag', 'nachbereitung'] as const
const STEPS = ['gegner', 'aufstellung', 'taktik', 'phasen', 'ansprache'] as const

export const Route = createFileRoute('/_app/spiele/$matchId')({
  validateSearch: (s: Record<string, unknown>): HubSearch => ({
    ...(TABS.includes(s.tab as (typeof TABS)[number]) ? { tab: s.tab as (typeof TABS)[number] } : {}),
    ...(STEPS.includes(s.schritt as (typeof STEPS)[number]) ? { schritt: s.schritt as (typeof STEPS)[number] } : {}),
  }),
  loader: async ({ context, params }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId || !scope.permissions.includes('matches.read')) return
    const qc = context.queryClient
    // Hub, plan and formations in parallel: the preparation opens without a second round trip.
    await Promise.all([
      qc.ensureQueryData(hubQuery(scope.teamId, scope.season, params.matchId)).catch(() => undefined),
      scope.permissions.includes('matches.plan')
        ? Promise.all([qc.ensureQueryData(planQuery(scope.teamId, scope.season, params.matchId)), qc.ensureQueryData(formationsQuery)]).catch(() => undefined)
        : undefined,
    ])
  },
  component: function Spiel() {
    return <MatchHub matchId={Route.useParams().matchId} search={Route.useSearch()} />
  },
})
